import { useEffect, useState } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const useMeraApne = () => {
  const [meraApne, setMeraApne] = useState();

  const getMeraApne = async () => {
    try {
      const response = await getApi(apiEndPoints.allMeraApne);
      if (response && response.status === 200) {
        setMeraApne(response?.data[0]);
      }
    } catch (error) {
      console.error("Failed to fetch Mera-Apne data", error);
    }
  };

  useEffect(() => {
    getMeraApne();
  }, []);

  return { meraApne };
};

export default useMeraApne;